import React from 'react';
import {
  Keyboard,
} from 'react-native';

import { grtAtom, grtStt } from './_csRcl';

import * as _hm from './_hm';
import * as _ht from './_ht';
import * as _gv from './_gv';

const $getBdySftY = (pz: {
  kbdMsrH: _ht.n,
  kbdMsrY: _ht.n,
  iptMsrH: _ht.n,
  iptMsrY: _ht.n,
}) => {

  const _gDsnz = _gv.useDsnz();

  const _ostH = 0; // offset H
  if (pz.iptMsrY == undefined) return 0;
  let _dy = (pz.iptMsrY + pz.iptMsrH + _ostH) - (pz.kbdMsrY);
  if (_dy >= (pz.kbdMsrH - _gDsnz.crt.ftrH)) _dy = pz.kbdMsrH - _gDsnz.crt.ftrH; // キーボード分のみが対象
  if (_dy < 0) _dy = 0; // 下側が被った場合のみが対象

  return _dy;
};

const $atomKbdMsrz = grtAtom('kbd.kbdMsrz', {
  bShow: false,
  msrz: {}, // do not set initial value
  bdySftY: 0,
});

const $atomIptMsrz = grtAtom('kbd.iptMsrz', {
  ox: 0,
  oy: 0,
  w: 0,
  h: 0,
  px: 0,
  py: 0,
});

export const useKbdMsrz = () => {
  return grtStt($atomKbdMsrz)
};

export const useIptMsrz = () => {
  const _sz = grtStt($atomIptMsrz);
  return {
    ..._sz,
    clrMsrz: () => { // set at input onBlur
      const _dz = {
        ox: 0,
        oy: 0,
        w: 0,
        h: 0,
        px: 0,
        py: 0,
      };
      _sz.set(_dz);
    },
    setMsrz: (poRefView: _ht.a) => { // set at input onFocus, onContentSizeChange
      poRefView.current.measure((_oX: _ht.n, _oY: _ht.n, _w: _ht.n, _h: _ht.n, _pX: _ht.n, _pY: _ht.n) => {
        const _dz = {
          ox: _oX,
          oy: _oY,
          w: _w,
          h: _h,
          px: _pX,
          py: _pY,
        };
        _sz.set(_dz);
      });
    }
  }
};

export const KbdRoot = React.memo((pz: {
  children: React.ReactElement,
}): React.ReactElement => {

  const _sKbdMsrz = useKbdMsrz();
  const _sIptMsrz = useIptMsrz();

  React.useEffect(() => {

    const _lnrShow = Keyboard.addListener('keyboardDidShow', (_e) => { //_e.endCoodinates.height : keyboard height
      if (_hm.f(_sKbdMsrz.crt.msrz) == false) { // 表示のばたつき防止
        const _dz = {
          bShow: true,
          msrz: _e.endCoordinates
        };
        _sKbdMsrz.set(_dz);
      }
    });

    const _lnrHide = Keyboard.addListener('keyboardDidHide', () => {
      const _dz = {
        bShow: true,
        msrz: {}
      };
      _sKbdMsrz.set(_dz);
    });

    return () => {
      _lnrShow.remove();
      _lnrHide.remove();
    };

  }, [])

  React.useEffect(() => {
    if (_sKbdMsrz.crt.bShow) { // show
      _sKbdMsrz.set({
        bdySftY: $getBdySftY({
          kbdMsrH: _sKbdMsrz.crt.msrz.height,
          kbdMsrY: _sKbdMsrz.crt.msrz.screenY,
          iptMsrH: _sIptMsrz.crt.h,
          iptMsrY: _sIptMsrz.crt.py,
        }),
      });
    }
    else { // hide
      _sKbdMsrz.set({
        bdySftY: 0,
      });
    }
  }, [
    _sKbdMsrz.crt.bShow,
    _sKbdMsrz.crt.msrz.height,
    _sKbdMsrz.crt.msrz.screenY,
    _sIptMsrz.crt.h,
    _sIptMsrz.crt.py,
  ])

  return (
    pz.children
  )

});
